module.exports = __webpack_public_path__ + "static/media/programming_world_map.2e25ff69.jpg";